define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext", "./employeeActions"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext, EmployeeActions) {
    "use strict";
    var Employees = /** @class */ (function () {
        function Employees() {
            this.userCanEditEmployee = ko.observable(UserContext.hasAccess("Admin,Employee.Edit,Employee.Delete"));
            this.userCanDeleteEmployee = ko.observable(UserContext.hasAccess("Admin,Employee.Delete"));
            this.filterByAny = ko.observable("");
        }
        Employees.prototype.init = function () {
            var self = this;
            $("#page-title").text("Members");
            tools.ajaxGet({
                url: "/Employee/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.employeeLookupList = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.employeeActions = new EmployeeActions();
                    self.employeeActions.afterSuccess = function () {
                        self.employeeTable.refresh();
                    };
                    self.initGrid(self.employeeLookupList.GridStructures.EmployeeStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        Employees.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblEmployeeKendo";
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "100px",
                template: function (dataItem) {
                    var html = "";
                    html += "<a class=\"btn btn-sm btn-yellow btn-edit\" href=\"/Employee/Details/".concat(dataItem.Id, "\"><i class=\"fa fa-edit \"></i></a>");
                    if (self.userCanDeleteEmployee) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.employeeTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Employee/GetEmployees",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#employee-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "Employee",
                    title: "Members",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.employeeTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.employeeTable.getGridData().dataSource.read();
            });
            $("#" + gridId + " tbody").on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.employeeActions.deleteEmployeeConfirm(data.Id, "".concat(data.FirstName, " ").concat(data.LastName));
                event.preventDefault();
            });
        };
        Employees.prototype.editEmployee = function (id) {
            var self = this;
            self.employeeActions.editEmployee(id);
        };
        Employees.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("Employee");
                dataLogs.open("Employees logs");
                event.preventDefault();
            }
        };
        return Employees;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Employee/Index")) {
            log.log("Initialize Employees list");
            $(function () {
                (new Employees()).init();
            });
        }
    }, 0);
    return Employees;
});
//# sourceMappingURL=employees.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/employee/employees.js
// module id = 298
// module chunks = 2